export default "__VITE_ASSET__Do7RN$vP__"